import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { colors } from '@/globalStyles';
import { getPageState, getPageDeleteOptions } from '@/helpers';
import {
  deleteSelectedPage, deleteAllSections, deleteWholeContent, deleteSelectedContents,
  deleteSectionThunk, deleteSelectedElementThunk, deleteSelectedSectionsContentThunk
} from '@/actions';
import { ContextMenuStyled, ContextMenuItemStyled } from '../styles';

const DeleteContextMenu = props => {
  const { isMatrix, disableDeleteElements, handleClose } = props;
  const pages = useSelector(state => state.core.pages);
  const sectionsSelection = useSelector(state => state.core.sectionsSelection);
  const [deleteActions, setDeleteActions] = React.useState([]);
  const dispatch = useDispatch();
  const isSinglePage = Object.keys(pages).length === 1;
  const sectionsSelectionCount = Object.values(sectionsSelection).length || 0;
  const pageState = getPageState(isSinglePage, isMatrix, !!sectionsSelectionCount);
  const isDeleteActionsAvailable = deleteActions.length > 0;

  React.useEffect(async () => {
    try {
      const actions = await getPageDeleteOptions(pageState, sectionsSelectionCount, {
        deletePage: () => dispatch(deleteSelectedPage(true)),
        deleteSection: () => dispatch(deleteSectionThunk()),
        deleteAllSections: () => dispatch(deleteAllSections()),
        deleteWholeContent: () => dispatch(deleteWholeContent()),
        deleteSectionContent: () => dispatch(deleteSelectedSectionsContentThunk()),
        deleteSelectedContents: () => dispatch(deleteSelectedContents()),
        deleteSelectedSections: () => dispatch(deleteSelectedElementThunk()),
      });

      setDeleteActions(actions);
    } catch (error) {
      console.error('[Error][getPageDeleteOptions]:', error);
    }
  }, []);

  return isDeleteActionsAvailable ? (
    <ContextMenuStyled>
      {deleteActions.map((item, index) => {
        const disabled = disableDeleteElements && item.defaultMessage === 'Delete selected element' ? true : false;
        const handleClick = () => {
          if (!disabled) {
            item.action();
            handleClose();
          }
        };

        return (
          <ContextMenuItemStyled key={index} color={colors.red} disabled={disabled} onClick={handleClick}>
            <FormattedMessage id={item.title} defaultMessage={item.defaultMessage} />
          </ContextMenuItemStyled>
        );
      })}
    </ContextMenuStyled>
  ) : null;
};

export default DeleteContextMenu;
